module.exports = "./dist/dmap/leaflet/layers.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/layers.png
// module id = 46
// module chunks = 4